<template>
  <div>
    <es-loader 
      v-if="loading" 
      style="margin: 1rem" />
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
    />
    <div v-else>
      <div>
        <es-profile-header>
          <template #profile-header>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="header-title has-text-weight-bold">
                    Search Information
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template #profile-overview>
            <div class="columns">
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ Date.now() | formatDateMMDDYYYYHHMM }}
                  </div>
                  <div class="column-subtitle">Search Date</div>
                </div>
              </div>
              <div class="column">
                <div class="column-content">
                  <div class="column-title">
                    {{ totalCount }}
                  </div>
                  <div class="column-subtitle">Search Result</div>
                </div>
              </div>
            </div>
          </template>
        </es-profile-header>
        <div class="tabs-container">
          <div class="tabs no-bottom-border">
            <ul>
              <router-link
                :to="{ name: 'PidSearchDownload' }"
                tag="li" 
                replace
              >
                <a aria-label="Download Transaction" role="link" tabindex="0">
                  DOWNLOAD
                </a>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
      <search-download 
      :active="active" 
      :districtCode="districtCode" 
      :schoolCode="schoolCode" 
      :schoolYear="schoolYear"
      :totalCount="totalCount" 
      :personType="personType" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import EsException from '@/components/EsException.vue';
import EsLoader from '@/components/EsLoader.vue';
import EsProfileHeader from '@/components/EsProfileHeader.vue';
import PidStatusInfoIcon from '@/components/PidStatusInfoIcon.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import PermissionManager from '@/mixins/PermissionManager';
import SearchDownload from '@/views/PersonId/Search/SearchDownload.vue';

export default {
  mixins: [
    BreadcrumbsManager,
    PermissionManager,
  ],
  components: {
    EsException,
    EsLoader,
    EsProfileHeader,
    PidStatusInfoIcon,
    SearchDownload,
  },
  props: {
    active: {
      type: Boolean,
    },
    districtCode: {
      type: String,
    },
    personType: {
      type: String,
    },
    schoolCode: {
      type: String,
    },
    schoolYear: {
      type: String,
    },
    totalCount: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      loadingError: false,
    };
  },
  // created() {
  //   this.loadTransaction();
  // },
  mounted() {
    this.setBreadcrumbs();
  },
  methods: {
    formatDateTime(value) {
      return moment(value).format('MM/DD/YYYY h:mm A');
    },
    setBreadcrumbs() {
      this.setBreadcrumb([
        { text: 'Home', to: { name: 'personId' } },
        { text: 'Download Search Result ', to: {} },
      ]);
    },
    // async loadTransaction() {
    //   try {
    //     this.loading = true;
    //     this.loadingError = false;
    //     const res = await axios.get(`personid/transactions/${this.transactionId}`);
    //     this.transaction = res.data;
    //   } catch (error) {
    //     this.apiMsg = `${error.response.status === 500
    //       ? 'Network Error'
    //       : error.response.data.message}`;
    //     this.showNotification('danger', [this.apiMsg]);
    //     this.loadingError = true;
    //   } finally {
    //     this.loading = false;
    //   }
    // },
  },
};
</script>
<style lang="sass" scoped>
  .header-title
    color: #000 !important
    font-weight: 700 !important
  .header-subtitle
    color: #6c757d
  .margin-bottom
    margin-bottom: 1rem
  .max-width
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    max-width: 20ch
  .progress-bar
    height: 5px
    width: 75px
    margin-bottom: 3px
    margin-left: 1rem
</style>
